<template lang="pug">
div
  .row.mb-4.mt-2(v-if="user.role === 'store' && checkRestrictedDays()")
    .col.d-flex.flex-column
      .mt-2.flex-row.d-flex()
        .material-icons.icon-color.mr-2 watch_later
        span Actualmente no podemos crear envíos en este horario. Podrás crear envíos nuevamente el domingo a partir de las 12:01 Hrs.
  b-form(v-if="user.role === 'store' ? !checkRestrictedDays() : true" @submit.stop.prevent="onSubmit")
    .box-form
      .material-icons.icon-input perm_identity
      b-form-group(
        label-for="customer-input"
        invalid-feedback="Este campo es requerido"
      )
        .input-title Cliente
        b-form-input#customer-input.input(
          v-model="form.customerName"
          maxlength="150"
          :state="$v.$dirty ? !$v.form.customerName.$invalid : null"
        )
    hr.linea
    .box-form
      .material-icons.icon-input local_phone
      b-form-group(
        label-for="customer-phone-input"
      )
        .input-title Teléfono Cliente
        b-input-group
          b-input-group-prepend
            .input-group-text(style="background-color: transparent; border: none; padding-right: 0")
              | +56
          b-form-input#customer-phone-input.input(
            v-model="form.customerPhone"
            :formatter="phoneNumberFormatter"
          )
    hr.linea
    .box-form
      .material-icons.icon-input email
      b-form-group(
        label-for="customer-email-input"
      )
        .input-title Email Cliente
        b-form-input#customer-email-input.input(
          v-model="form.customerEmail"
        )
    hr.linea
    .box-form(v-if="user.role!=='store' && !driverId")
      .material-icons.icon-input perm_identity
      b-form-group(
        label-for="driver-input"
      )
        .input-title Conductor
        v-select( v-model="form.driverId" :options="driverOptions" :reduce="driver => driver.value" style="min-height: 40px")
    .box-form(v-if="user.role!=='store'")
      .material-icons.icon-input store
      b-form-group(
        label-for="store-input"
      )
        .input-title Tienda
        v-select#store-input(
          v-model="form.storeId"
          :reduce="store => store.value"
          :options="storeOptions"
        )
    .box-form(v-if="!date && user.role!=='store'")
      .material-icons.icon-input calendar_today
      b-form-group(
        label-for="date-input"
        invalid-feedback="Este campo es requerido"
      )
        .input-title Fecha
        b-form-input#date-input.input(
          v-model="form.date"
          type="date"
          :state="$v.$dirty ? !$v.form.date.$invalid : null"
        )
    hr.linea(v-if="user.role!=='store' && !date")
    .box-form
      .material-icons.icon-input place
      b-form-group(
        label-for="commune-input"
      )
        .input-title Comuna
        b-form-input#commune-input.input(
          v-model="form.address.commune"
          maxlength="256"
        )
    hr.linea
    .box-form
      .material-icons.icon-input place
      b-form-group(
        label-for="street-input"
      )
        .input-title Dirección
        b-form-input#street-input.input(
          v-model="form.address.street"
          maxlength="256"
        )
    hr.linea
    .box-form
      .material-icons.icon-input tag
      b-form-group(
        label-for="street-input"
        :invalid-feedback="errors.externalId"
      )
        .input-title ID Externo (Opcional)
        b-form-input.input(
          :disabled="editMode"
          placeholder="ID único para identificar el envío en sus sistemas"
          v-model="form.externalId"
          :state="errors.externalId ? false : null"
          maxlength="256"
        )
    hr.linea
    .text-right
    div(v-if="editMode")
      .box-form
        .material-icons.icon-input local_shipping
        b-form-group(
          label-for="partner-input"
        )
          .input-title Partner
          b-form-select#partner-input.input(
            v-model="form.partnerCode"
          )
            b-form-select-option(:value="null") Selecciona un Partner
            b-form-select-option(
              v-for="partner in partnerOptions"
              :key="partner.value"
              :value="partner.value"
            ) {{ partner.text }}
      hr.linea
      b-card.mb-2(
        v-if="delivery.lastPartnerSyncAt !== null && delivery.partnerCode !== null"
        variant="info"
        no-body
        style="margin-left: 37px; border-radius: 5px; background-color: #F5F5F5; padding: 10px; position: relative;"
      )
        div(style="font-weight: bold; font-size: 14px;") Seguimiento Partner
        div(style="font-size: 12px;") Ultima Sincronización: {{$moment(delivery.lastPartnerSyncAt).format('DD-MM-YYYY HH:mm')}}
        div(style="font-size: 12px;") Codigo de seguimiento: {{delivery.partnerDeliveryId}}
        div(style="font-size: 12px;") Estado: {{partnerUtils.partnerDeliveryStatusLabels[delivery.partnerCode][delivery.partnerDeliveryStatus]}}
      b-card.mb-2(
        v-if="delivery.partnerDeliverySyncError"
        variant="danger"
        no-body
        style="margin-left: 37px; border-radius: 5px; background-color: #F5F5F5; padding: 10px; max-height: 100px; overflow-y: auto;"
      )
        div(style="font-weight: bold; font-size: 14px;") Error de Sincronización
        div(style="font-size: 12px;") {{delivery.partnerDeliverySyncError}}
      .box-form
        .material-icons.icon-input place
        b-form-group(
          label-for="state-input"
        )
          .input-title Estado
            span(v-if="delivery.partnerCode" style="color: #939393; font-size: 12px;")  (No se puede modificar mientras se tenga un partner)
          b-form-select#state-input.input(v-model="form.state" :disabled="!!delivery.partnerCode")
            b-form-select-option(:value="null") Por entregar
            b-form-select-option(:value="'entregado'") Entregado
            b-form-select-option(:value="'pendiente'") Pendiente
            b-form-select-option(:value="'rechazado'") Rechazado
            b-form-select-option(:value="'cancelado'") Cancelado
      hr.linea
      VFormField(
        title="Recibido por"
        type="input"
        icon="person"
        v-model="form.receiverName"
      )
      VFormField(
        title="RUT"
        type="input"
        icon="badge"
        v-model="form.receiverRut"
      )
      .box-form
        .material-icons.icon-input place
        b-form-group(
          label-for="state-input"
        )
          .input-title Comentario
          b-form-textarea#commentary-input.input(
            v-model="form.commentary"
            maxlength="256"
          )
      hr.linea
    b-form-checkbox.ml-2(v-if="user.role==='admin' && !noIncudeHide" v-model="form.hide") Ocultar este envío
    .text-right
      b-button.boton(type="submit" :disabled="loading") Guardar
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MakeToastMixin from '../mixins/MakeToastMixin'
import { required } from 'vuelidate/lib/validators'
import phoneNumberFormatter from '../../shared/phoneNumberFormatter'
import partnerUtils from '../../utils/partnerUtils'
import VFormField from '@/components/UI/VFormField'

export default {
  mixins: [MakeToastMixin],
  components: {
    VFormField
  },
  props: {
    delivery: {
      type: Object,
      default: null
    },
    editMode: Boolean,
    driverId: Number,
    noIncudeHide: Boolean,
    date: [Date, String]
  },
  data() {
    return {
      partnerUtils,
      loading: false,
      isException: false,
      noExceptionAllowed: false,
      errors: {},
      form: {
        customerName: this.editMode ? this.delivery.customerName : '',
        customerPhone: this.editMode ? this.delivery.customerPhone : '',
        customerEmail: this.editMode ? this.delivery.customerEmail : '',
        driverId: this.driverId ? this.driverId : (this.editMode ? this.delivery.driverId : null),
        storeId: this.editMode ? this.delivery.storeId : null,
        date: this.date ? this.date : (this.editMode ? this.$moment(this.delivery.date.substring(0, 10)).format('YYYY-MM-DD') : ''),
        state: this.editMode ? this.delivery.state : null,
        commentary: this.editMode ? this.delivery.commentary : '',
        externalId: this.editMode ? this.delivery.externalId : '',
        hide: this.editMode ? this.delivery.hide : false,
        partnerCode: this.editMode ? this.delivery.partnerCode : null,
        receiverName: this.editMode ? this.delivery.receiverName : '',
        receiverRut: this.editMode ? this.delivery.receiverRut : '',
        address: {
          commune: this.editMode ? this.delivery.address.commune : '',
          street: this.editMode ? this.delivery.address.street : ''
        }
      }
    }
  },
  validations() {
    const form = {
      customerName: { required },
      date: { required }
    }
    return { form }
  },
  methods: {
    ...mapActions([
      'createDelivery',
      'updateDelivery',
      'listUser',
      'listStore',
      'checkWithdrawalHour',
      'listExceptions',
      'checkUniqueExternalId'
    ]),
    phoneNumberFormatter,
    async validateExternalId() {
      try {
        if (!this.form.externalId?.trim() || !this.form.storeId) return
        const response = await this.checkUniqueExternalId({
          data: {
            externalId: this.form.externalId,
            storeId: this.form.storeId
          }
        })
        this.errors.externalId = response.data.isUnique ? null : 'El ID externo debe ser único'
      } catch (error) {
        this.errors.externalId = 'Error al verificar el ID externo'
      }
    },
    goToPartnerDeliveryPage(deliveryPartnerId, partnerCode) {
      const partnerDeliveryLink = {
        [partnerUtils.partners.FAZT]: `https://staging-panel.fazt.cl/shipments/${deliveryPartnerId}`,
        [partnerUtils.partners.DOCE_HORAS_ENVIOS]: `https://socios.12horasenvios.cl/envios-tienda?search=${deliveryPartnerId}`
      }
      window.open(partnerDeliveryLink[partnerCode], '_blank')
    },
    async onSubmit() {
      this.loading = true
      this.errors = {}

      if (!this.editMode) {
        await this.validateExternalId()
      }

      if (this.$v.$invalid || Object.values(this.errors).some(Boolean)) {
        this.$v.$touch()
      } else {
        if (this.editMode) {
          await this.onUpdateDelivery()
        } else {
          await this.onCreateDelivery()
        }
      }
      this.loading = false
    },
    async onCreateDelivery() {
      const response = await this.createDelivery({ data: this.form })
      if (response.status === 201) {
        this.makeSuccessToast('El envío se creó correctamente')
        this.$emit('done')
        if (this.$route.meta.back) {
          this.$router.push(this.$route.meta.back)
        }
      } else if (response.status >= 400) {
        this.makeDangerToast(response.data.message || 'Error al crear el envío')
      }
    },
    async onUpdateDelivery() {
      const data = { ...this.form }
      const response = await this.updateDelivery({ id: this.delivery.id, data })
      if (response.status === 200) {
        this.makeSuccessToast('El envío se editó correctamente')
        this.$emit('done')
      } else if (response.status >= 400) {
        this.makeDangerToast(response.data.message || 'Error al editar el envío')
      }
    },
    checkRestrictedDays() {
      /* *** Reglas de Tiendas para crear envíos ***

        El horario para crear envíos, para el mismo día, es de 00:00 hasta las 12:00 Horas.
        A partir de las 12:01 Horas el envío se creará para el día siguiente.

      */
      const currentDate = this.$moment.tz('America/Santiago')
      const hours = currentDate.hours()
      const minutes = currentDate.minutes()
      const day = currentDate.day()
      /*
        Los días sábados a partir de las 12:01 hrs hasta las 12:00 horas del día domingo no se podrá agendar
        en dias UTC el sábado es 6 y el Domingo es 0
      */
      const saturday = (day === 6 && hours === 12 && minutes >= 1) || (day === 6 && hours > 12)
      const sunday = (day === 0 && hours === 12 && minutes === 0) || (day === 0 && hours < 12)

      return saturday || sunday
    },
    getDeliveryDate() {
      const currentDate = this.$moment.tz('America/Santiago')
      const hours = currentDate.hours()
      const minutes = currentDate.minutes()

      console.log(this.checkRestrictedDays(), 'Horario Restringido')
      if (Number(hours) >= 12) {
        if (Number(hours) === 12 && Number(minutes) === 0) {
          return currentDate
        }
        const tomorrow = currentDate.add(1, 'days')
        // console.log('El delivery se enviará mañana: ', tomorrow.format('DD/MM/YYYY'))
        return tomorrow
        // return currentDate.format('YYYY-MM-DD')
      } else {
        // console.log('El delivery se enviará hoy: ', currentDate.format('DD/MM/YYYY'))
        return currentDate
      }
    }
  },
  computed: {
    ...mapGetters(['stores', 'users', 'user', 'exceptions']),
    partnerOptions() {
      return partnerUtils.partnerSelectOptions
    },
    storeOptions() {
      const stores = []
      stores.push({ value: null, label: 'Selecciona una Tienda' })
      this.stores.forEach(store => {
        stores.push({ value: store.id, label: store.name })
      })
      return stores
    },

    driverOptions() {
      const users = [
        { value: null, label: 'Selecciona un Conductor' }
      ]
      const drivers = this.users.filter(user => user.role === 'delivery')
      drivers.forEach(user => {
        users.push({ value: user.id, label: user.name + ' ' + user.lastName })
      })
      return users
    }
  },
  async created() {
    if (this.user.role === 'admin') {
      if (!this.driverId) {
        this.listUser()
      }
      this.listStore()
    }
    if (this.user.role === 'store') {
      this.form.storeId = this.user.storeId
      this.form.date = this.getDeliveryDate().format('YYYY-MM-DD')
    }
    if (this.user.role === 'delivery') {
      if (!this.driverId) {
        this.listUser()
      }
      this.listStore()
    }
  }
}
</script>
